import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  DataBlocks,
  Link,
  Button,
} from 'components';

import { formatLogin } from 'utils/formatString';

import { USER_TYPES } from '../../constants';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const isFttb = (type) => type === USER_TYPES.FTTB;

const IncomingLinkageRequest = ({
  initiatorName,
  isCanceling,
  type,
  updateLinkageRequest,
  messageText,
  acceptText,
  declineText,
  initiatorType,
}) => (
  <DataBlocks.TableRow>
    <DataBlocks.TableCell
      className={cx('cell')}
      colSpan="10"
    >
      <div className={cx('request')}>
        <div className={cx('login')}>
          {formatLogin(initiatorName, isFttb(initiatorType))}
        </div>
        <div
          className={cx('message')}
        >
          {messageText}
        </div>
        <div className={cx('buttons')}>
          <Button
            className="default"
            isLoading={isCanceling}
            onClick={() => updateLinkageRequest({
              linkedLogin: initiatorName,
              requestType: type,
              accepted: true,
            })}
          >
            {acceptText}
          </Button>
          {!isCanceling
          && (
            <Link
              className={cx('cancelLink')}
              onClick={() => !isCanceling && updateLinkageRequest({
                linkedLogin: initiatorName,
                requestType: type,
                accepted: false,
              })}
            >
              {declineText}
            </Link>
          )}
        </div>
      </div>
    </DataBlocks.TableCell>
  </DataBlocks.TableRow>
);

IncomingLinkageRequest.propTypes = {
  initiatorName: PropTypes.string,
  initiatorType: PropTypes.string,
  isCanceling: PropTypes.bool,
  type: PropTypes.string,
  updateLinkageRequest: PropTypes.func,
  messageText: PropTypes.any,
  acceptText: PropTypes.any,
  declineText: PropTypes.any,
};

export default IncomingLinkageRequest;
